import React, { useState } from "react";

import { NO_DISPLAY_DATA } from "../constants";
import {
  DocumentSearchQuery,
  RegionSearchDocument,
} from "../types/search-display";
import {
  AuDocSearchContext,
  DocSearchQueryContext,
  EuDocSearchContext,
  UsDocSearchContext,
} from "./doc-search-context";

interface DocSearchContextProps {
  children: React.ReactNode;
}

const DocSearchContextWrapper = ({ children }: DocSearchContextProps) => {
  const [docSearchQueryState, setDocSearchQueryState] =
    useState<DocumentSearchQuery>({
      docId: "",
      docType: NO_DISPLAY_DATA,
      collapsedView: 1,
      revId: "",
      useRevId: false,
      includeDeleted: false,
    });

  const [usRegionSearchDocument, setUsRegionSearchDocument] =
    useState<RegionSearchDocument>({
      documentRawResponse: "",
      isLoading: false,
    });

  const [euRegionSearchDocument, setEuRegionSearchDocument] =
    useState<RegionSearchDocument>({
      documentRawResponse: "",
      isLoading: false,
    });

  const [auRegionSearchDocument, setAuRegionSearchDocument] =
    useState<RegionSearchDocument>({
      documentRawResponse: "",
      isLoading: false,
    });

  const documentSearchContextValue = {
    docSearchQueryState: docSearchQueryState,
    setDocSearchQueryState: setDocSearchQueryState,
  };

  const usDocumentSearchContextValue = {
    usRegionSearchDocument,
    setUsRegionSearchDocument,
  };

  const euDocumentSearchContextValue = {
    euRegionSearchDocument,
    setEuRegionSearchDocument,
  };

  const auDocumentSearchContextValue = {
    auRegionSearchDocument,
    setAuRegionSearchDocument,
  };

  return (
    <DocSearchQueryContext.Provider value={documentSearchContextValue}>
      <UsDocSearchContext.Provider value={usDocumentSearchContextValue}>
        <EuDocSearchContext.Provider value={euDocumentSearchContextValue}>
          <AuDocSearchContext.Provider value={auDocumentSearchContextValue}>
            {children}
          </AuDocSearchContext.Provider>
        </EuDocSearchContext.Provider>
      </UsDocSearchContext.Provider>
    </DocSearchQueryContext.Provider>
  );
};

export default DocSearchContextWrapper;
